module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('el-row', [_c('div', {
    staticClass: "titles"
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("备注")])])]), _vm._v(" "), _c('el-row', [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 5
      },
      "disabled": _vm.editDisableState,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.coms),
      callback: function($$v) {
        _vm.coms = $$v
      },
      expression: "coms"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "titles"
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("人才培养方案原件")])]), _vm._v(" "), _c('div', {
    staticClass: "uploadTips"
  }, [_vm._v("第一次保存之后才可上传人才培养方案原件")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "action": _vm.url,
      "file-list": _vm.fileList,
      "data": _vm.param,
      "on-error": _vm.onError,
      "on-success": _vm.onSuccess,
      "before-remove": _vm.beforeRemove,
      "on-remove": _vm.onRemove,
      "limit": 1,
      "on-exceed": _vm.onExceed,
      "disabled": _vm.nshow
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "success",
      "disabled": _vm.nshow
    }
  }, [_vm._v("上传")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.downloadScheme.apply(null, arguments)
      }
    }
  }, [_vm._v("下载")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger",
      "disabled": _vm.nshow
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onRemove.apply(null, arguments)
      }
    }
  }, [_vm._v("删除")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a4ce632"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/teachingManage/teachingScheme/comment.vue
// module id = 1825
// module chunks = 502